<template>
  <v-card :value="value" v-bind="$attrs" self-align="center">
    <v-card-actions v-if="!isOnMobile" class="ma-0 pa-0" align="center" justify="center">
      <v-card-text class="subtitle-1 ma-0 pa-1">
        {{ title }}
      </v-card-text>
    </v-card-actions>

    <t-divider></t-divider>

    <v-card-actions :style="'background: ' + Colors.MenuColor + '; color: ' + Colors.MenuTextColor" class="ma-0 pa-1" align="center" justify="center">
      <v-card-text class="subtitle-1 ma-0 pa-0">
        {{ selectedText }}
      </v-card-text>
    </v-card-actions>

    <t-divider></t-divider>

    <v-card-text class="pa-2">
      <v-row>
        <v-col cols="7">
          <v-select v-model="selectedMonth" :items="months" item-text="text" item-value="value" dense outlined hide-details />
        </v-col>

        <v-col cols="5">
          <v-select v-model="selectedYear" :items="years" dense outlined hide-details />
        </v-col>
      </v-row>

      <t-divider class="mt-2"></t-divider>

      <v-row class="ma-0 pa-1" justify="center">
        <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded outlined small color="primary" @click="setCurrentMonth()">
          {{ TR.ThisMonth }}
        </v-btn>
      </v-row>

      <t-divider></t-divider>

      <v-row :class="isOnMobile ? 'ma-0 pa-0' : 'ma-1 pa-0'">
        <v-spacer></v-spacer>

        <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="cancelInput()">
          {{ buttonCancelText }}
        </v-btn>

        <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="handleInput()">
          {{ buttonOKText }}
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import DataManager from "../../js/DataManager";
import { TR } from "../../main";

export default {
  props: {
    value: {
      type: Date,
      default: null,
    },

    minYear: {
      type: Number,
      default: () => new Date().getFullYear() - 5,
    },

    maxYear: {
      type: Number,
      default: () => new Date().getFullYear(),
    },
  },

  data() {
    let dt = this.value || new Date();

    return {
      TR,
      title: TR.TDatePicker_ChooseRange,

      selectedMonth: dt.getMonth(),
      selectedYear: dt.getFullYear(),

      buttonOKText: TR.OK,
      buttonCancelText: TR.Cancel,
    };
  },

  computed: {
    months() {
      return DataManager.MonthNames.map((x, idx) => ({
        value: idx,
        text: x,
      }));
    },

    years() {
      let arr = [];

      for (let y = this.maxYear; y >= this.minYear; y--) {
        arr.push(y);
      }

      return arr;
    },

    selectedText() {
      return DataManager.MonthNames[this.selectedMonth] + " " + this.selectedYear;
    },
  },

  methods: {
    setCurrentMonth() {
      let d = new Date();

      this.selectedMonth = d.getMonth();
      this.selectedYear = d.getFullYear();
    },

    handleInput() {
      this.dialog.result = (this.selectedYear - 2000) * 100 + this.selectedMonth;
      this.dialog.close();
    },

    cancelInput() {
      this.dialog.result = null;
      this.dialog.close();
    },
  },

  watch: {
    value: {
      handler() {
        if (!this.value) return;

        this.selectedMonth = this.value.getMonth();
        this.selectedYear = this.value.getFullYear();
      },
      deep: true,
    },
  },

  created() {
    if (this.dialog.data instanceof Date) {
      this.selectedMonth = this.dialog.data.getMonth();
      this.selectedYear = this.dialog.data.getFullYear();
    }

    if (this.dialog.options) {
      if (this.dialog.options.title != undefined) {
        this.title = this.dialog.options.title;
      }

      if (this.dialog.options.buttonOKText != undefined) {
        this.buttonOKText = this.dialog.options.buttonOKText;
      }

      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
    }
  },
};
</script>

<style scoped>
</style>